import { useLayoutEffect, useMemo, useRef } from "react";
import { useTournamentContext } from "../../../../hook/context";
import { EditTournamentTab } from "../../../../hook/useTournamentTab";
import { EditTournamentTabItem, EditTournamentTabWrapper } from "../../style";

const EditTournamentTabs = () => {
  const { setTournamentTab, isTournamentTab, tournamentId, tournamentTab } =
    useTournamentContext();
  const tabItemRefs = useRef<Map<EditTournamentTab, HTMLDivElement>>(
    new Map(),
  );

  const tabs = useMemo(() => {
    if (tournamentId) {
      return [
        { tab: EditTournamentTab.BASE, name: "토너먼트 기본 설정" },
        { tab: EditTournamentTab.PRIZE, name: "프라이즈 설정" },
        { tab: EditTournamentTab.PARTICIPATION, name: "참가 설정" },
        { tab: EditTournamentTab.STRUCTURE, name: "스트럭쳐 설정" },
        { tab: EditTournamentTab.LIVE, name: "유튜브 LIVE" },
      ];
    }
    return [
      { tab: EditTournamentTab.BASE, name: "토너먼트 기본 설정" },
      { tab: EditTournamentTab.PRIZE, name: "프라이즈 설정" },
      { tab: EditTournamentTab.PARTICIPATION, name: "참가 설정" },
      { tab: EditTournamentTab.STRUCTURE, name: "스트럭쳐 설정" },
      { tab: EditTournamentTab.RESERVATION, name: "예약 설정" },
      { tab: EditTournamentTab.LIVE, name: "유튜브 LIVE" },
    ];
  }, [tournamentId]);

  useLayoutEffect(() => {
    const el = tabItemRefs.current.get(tournamentTab);
    el?.scrollIntoView({
      behavior: "smooth",
      inline: "center",
      block: "nearest",
    });
  }, [tournamentTab]);

  return (
    <EditTournamentTabWrapper>
      {tabs.map((t) => (
        <EditTournamentTabItem
          key={t.tab}
          ref={(node) => {
            if (node) tabItemRefs.current.set(t.tab, node);
            else tabItemRefs.current.delete(t.tab);
          }}
          selected={isTournamentTab(t.tab)}
          onClick={() => setTournamentTab(t.tab)}
        >
          {t.name}
        </EditTournamentTabItem>
      ))}
    </EditTournamentTabWrapper>
  );
};

export default EditTournamentTabs;
